module.exports = __webpack_public_path__ + "static/img/Highlight.16900002.png";